import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async'; // ✅ SEO
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { Player, Controls } from '@lottiefiles/react-lottie-player';

export default function Facility() {
  const lottiee = require('../images/lottiee.json');
  const loading = require('../images/loading.json');

  const [facility, setFacility] = useState([]);
  const [loader, setloader] = useState(false);

  const facilityData = () => {
    setloader(true);
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch("https://api.padampura.com/FacilitiesList", requestOptions) // 🔧 Removed extra space
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          setFacility(result.data);
        }
      })
      .catch((error) => console.error("Fetch error:", error))
      .finally(() => setloader(false)); // ✅ Fixed: loader off
  };

  useEffect(() => {
    facilityData();
    scrollToTop();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Optional: Sanitize HTML (only if necessary)
  const sanitizeHtml = (html) => {
    return html ? html.replace(/<\/?p>/g, '').trim() : '';
  };

  return (
    <>
      {/* ✅ SEO Tags */}
      <Helmet>
        <title>Facilities at Padampura Temple | Jain Temple Amenities</title>
        <meta name="description" content="Explore the facilities available at Padampura Temple including accommodation, dining, prayer halls, and more for devotees and visitors." />
        <meta name="keywords" content="Padampura Temple Facilities, Jain Temple Amenities, Temple Accommodation, Devotee Facilities, Religious Services" />
        <meta name="author" content="Padampura Temple Administration" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social Sharing */}
        <meta property="og:title" content="Facilities - Padampura Temple" />
        <meta property="og:description" content="Discover the services and amenities offered at Padampura Temple for spiritual and physical well-being." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:site_name" content="Padampura Temple" />
        <meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
        <meta property="og:image:alt" content="Padampura Temple Logo" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://yourdomain.com/facilities" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Facilities at Padampura Temple",
            "url": "https://yourdomain.com/facilities",
            "description": "List of spiritual and physical facilities available for devotees at Padampura Temple.",
            "publisher": {
              "@type": "Organization",
              "name": "Padampura Temple",
              "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo192.png"
              }
            }
          })}
        </script>
      </Helmet>

      <div className='container mt-5 pt-5'>
        <h1 className='text-center text-decoration-underline' style={{ color: "#1f5156", fontFamily: "Poppins", fontWeight: 600, fontSize: 24 }}>
          FACILITIES
        </h1>

        {loader ? (
          <div className='text-center'>
            <p style={{ fontFamily: "Poppins", fontSize: 16 }}>Loading...</p>
            <Player autoplay loop src={loading} style={{ height: '200px', width: '200px' }}>
              <Controls visible={false} buttons={['play', 'repeat']} />
            </Player>
          </div>
        ) : facility.length === 0 ? (
          <div className='text-center'>
            <Player autoplay loop src={lottiee} style={{ height: '180px', width: '180px' }}>
              <Controls visible={false} buttons={['play', 'repeat']} />
            </Player>
            <p style={{ fontFamily: "Poppins", fontSize: 16, color: 'red' }}>No facilities data available.</p>
          </div>
        ) : (
          facility.map((item, index) => (
            <div key={index} className='row my-4'>
              <div className='col-lg-10 m-auto'>
                <h2
                  className='text-start'
                  style={{ fontFamily: "Poppins", fontSize: "1.1em", fontWeight: 600, color: '#1f5156' }}
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.FacilityName) }}
                />
                <p
                  className='text-start'
                  style={{ fontFamily: "Poppins", fontSize: ".8em", fontWeight: 400, color: '#333' }}
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.FacilityDescription) }}
                />
              </div>
            </div>
          ))
        )}
      </div>

      {/* ✅ Accessible Scroll-to-Top Button */}
      <button
        className="scroll-to-top-button border-0 rounded-2"
        onClick={scrollToTop}
        aria-label="Scroll back to top"
        style={{
          width: 40,
          height: 40,
          backgroundColor: "red",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1000,
          border: "none",
          cursor: "pointer",
          borderRadius: 5,
        }}
      >
        <IoArrowUpCircleOutline style={{ fontSize: 40 }} />
      </button>
    </>
  );
}